/* eslint-disable react-hooks/exhaustive-deps */
import {FC, useContext, useState, useEffect, useMemo} from 'react'
import {useQuery} from 'react-query'
import {
  createResponseContext,
  initialQueryResponse,
  initialQueryState,
  PaginationState,
  QUERIES,
  stringifyRequestQuery,
  WithChildren2,
} from '../../../../../_metronic/helpers'
import {getUsers} from './_requests'
import {User} from './_models'
import {useQueryRequest} from './QueryRequestProvider'
import {mycontext} from '../components/header/UserListFilterDropdown'
import {useSelector} from 'react-redux'

const QueryResponseContext = createResponseContext<User>(initialQueryResponse)
const QueryResponseProvider: FC<WithChildren2> = ({children, userType, customerCode}) => {
  const {state, updateState} = useQueryRequest()
  const [query, setQuery] = useState<string>(stringifyRequestQuery(state))
  const updatedQuery = useMemo(() => stringifyRequestQuery(state), [state])
  // const value = useContext(mycontext)
  const {currentpage, rowsPerPage, searchQuery, value, sort, orderWay} = useSelector(
    (state: any) => {
      if (userType === 'CONSUMER' && customerCode === 0) {
        return {
          value: state.table.RequesterManagement?.[0]?.filterData,
          currentpage: state.table.RequesterManagement?.[0]?.currentPage,
          rowsPerPage: state.table.RequesterManagement?.[0]?.rowsPerPage,
          searchQuery: state.table.RequesterManagement?.[0]?.searchQuery,
          sort: state.table.RequesterManagement?.[0]?.sort,
          orderWay: state.table.RequesterManagement?.[0]?.order,
        }
      } else if (userType === 'INTERPRETER') {
        return {
          value: state.table.InterperterManagement?.[0]?.filterData,
          currentpage: state.table.InterperterManagement?.[0]?.currentPage,
          rowsPerPage: state.table.InterperterManagement?.[0]?.rowsPerPage,
          searchQuery: state.table.InterperterManagement?.[0]?.searchQuery,
          sort: state.table.InterperterManagement?.[0]?.sort,
          orderWay: state.table.InterperterManagement?.[0]?.order,
        }
      } else if (userType === 'SYSTEM') {
        return {
          value: state.table.AdministratorManagement?.[0]?.filterData,
          currentpage: state.table.AdministratorManagement?.[0]?.currentPage,
          rowsPerPage: state.table.AdministratorManagement?.[0]?.rowsPerPage,
          searchQuery: state.table.AdministratorManagement?.[0]?.searchQuery,
          sort: state.table.AdministratorManagement?.[0]?.sort,
          orderWay: state.table.AdministratorManagement?.[0]?.order,
        }
      } else {
        return {
          value: state.table.CompanyUserManagement?.[0]?.filterData,
          currentpage: state.table.CompanyUserManagement?.[0]?.currentPage,
          rowsPerPage: state.table.CompanyUserManagement?.[0]?.rowsPerPage,
          searchQuery: state.table.CompanyUserManagement?.[0]?.searchQuery,
          sort: state.table.CompanyUserManagement?.[0]?.sort,
          orderWay: state.table.CompanyUserManagement?.[0]?.order,
        }
      }
    }
  )

  useEffect(() => {
    if (query !== updatedQuery) {
      setQuery(updatedQuery)
    }
  }, [updatedQuery])

  const {
    isFetching,
    refetch,
    data: response,
  } = useQuery(
    `${QUERIES.USERS_LIST}-${query}`,
    () => {
      return getUsers(query, userType, customerCode, value)
    },
    {
      cacheTime: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      enabled: !!value,
    }
  )
  useEffect(() => {
    if (value) {
      updateState({
        ...state,
        items_per_page: rowsPerPage,
        page: currentpage,
        search: searchQuery,
        sort: sort,
        order: orderWay,
        userType: userType,
        customerCode: customerCode,
      })
      refetch()
    }
  }, [value, refetch])

  return (
    <QueryResponseContext.Provider value={{isLoading: isFetching, refetch, response, query}}>
      {children}
    </QueryResponseContext.Provider>
  )
}

const useQueryResponse = () => useContext(QueryResponseContext)

const useQueryResponseData = () => {
  const {response} = useQueryResponse()
  if (!response) {
    return []
  }

  return response?.data || []
}

const useQueryResponsePagination = () => {
  const defaultPaginationState: PaginationState = {
    links: [],
    ...initialQueryState,
  }

  const {response} = useQueryResponse()
  if (!response || !response.payload || !response.payload.pagination) {
    return defaultPaginationState
  }
  return response.payload.pagination
}

const useQueryResponseLoading = (): boolean => {
  const {isLoading} = useQueryResponse()
  return isLoading
}

export {
  QueryResponseProvider,
  useQueryResponse,
  useQueryResponseData,
  useQueryResponsePagination,
  useQueryResponseLoading,
}
